<mat-dialog-content>
  <div class="nfc-dialog-container text-center p-4">
    <div *ngIf="status === 'scanning'" class="scanning-state">
      <div class="nfc-icon-wrapper mb-3">
        <mat-icon>nfc</mat-icon>
        <div class="scan-pulse"></div>
      </div>
      <h4 class="mb-2">NFC Ready</h4>
      <p class="text-muted">Please tap your card on the reader</p>
    </div>

    <div *ngIf="status === 'success'" class="success-state">
      <div class="mb-3">
        <i class="fa fa-check-circle fa-2x text-success"></i>
      </div>
      <h4 class="mb-2">Success!</h4>
      <p class="text-muted">Card detected: {{ cardUid }}</p>
    </div>

    <div *ngIf="status === 'error'" class="error-state">
      <div class="mb-3">
        <i class="fa fa-exclamation-triangle fa-2x text-danger"></i>
      </div>
      <h4 class="mb-2">Error</h4>
      <p class="text-muted mb-3">{{ errorMessage }}</p>
      <div class="d-flex justify-content-center gap-2">
        <button class="btn btn-light px-4" (click)="cancel()">
          Cancel
        </button>
        <button class="btn btn-primary px-4" (click)="retry()">
          Retry
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
